import { useEffect, useState } from 'react';
import '/assets/styles/pages/smf/menu.scss';

// Context
import { useGlobalState } from '@wearetla/tla-essentials-tools/utilities/global-state';

// Partials
import Loader from '/views/partials/loader';
import PriceBox from '/views/partials/pricebox';

// Services
import siteServices from '/services/site';

const getAllMenu = () => {
	return siteServices.getAllMenu();
};

const SMFLineup = ({ pageProps }) => {
	const [menuData, setMenuData] = useState(pageProps.menuData);
	const { setError } = useGlobalState();

	useEffect(() => {
		if (!menuData) {
			getAllMenu()
				.then((payload) => {
					setMenuData(payload);
				})
				.catch(() => {
					setError();
				});
		}
	}, [menuData]);

	return (
		<div className="menu-content wrapper">
			<div className="loader-container">
				<Loader loading={!menuData} />
				{menuData && (
					<ul className="menu-list">
						{menuData?.map((menuItem, nth) => (
							<li className="list-item" key={nth}>
								<strong>{menuItem.title}</strong>

								<PriceBox price={menuItem.price} />
							</li>
						))}
					</ul>
				)}
			</div>
		</div>
	);
};

SMFLineup.getServerProps = () => {
	return new Promise((resolve) => {
		Promise.all([getAllMenu()])
			.then(([menuData]) => {
				resolve({
					pageProps: {
						menuData,
					},
				});
			})
			.catch(() => {
				resolve({});
			});
	});
};

export default SMFLineup;
